/**
 * TCS "Overseas Tour Program Package" test - Income-Tax Act Sec. 206C(1G),
 * read with CBDT Circular 10/2023.
 *
 * TCS on a FOREIGN-travel sale applies only when the itinerary bundles at least
 * TWO of these three service groups:
 *   A. International travel ticket  -> FLIGHT
 *   B. Hotel / lodging / boarding   -> HOTEL, CRUISE
 *   C. Any other similar expense    -> ACTIVITY, TRANSFER, VAS
 *
 * A standalone air ticket, a standalone stay (any number of hotels/cities), or
 * services from a single group (only activities, only transfers, or
 * activity+transfer - all Group C) do NOT form a package, so no TCS. Whether
 * the destination is international is a separate check the caller applies.
 */
export function qualifiesAsTourPackage(componentKinds: readonly string[]): boolean {
  let hasTravel = false;
  let hasStay = false;
  let hasOther = false;
  for (const kind of componentKinds) {
    if (kind === 'FLIGHT') hasTravel = true;
    else if (kind === 'HOTEL' || kind === 'CRUISE') hasStay = true;
    else if (kind === 'ACTIVITY' || kind === 'TRANSFER' || kind === 'VAS') hasOther = true;
  }
  return [hasTravel, hasStay, hasOther].filter(Boolean).length >= 2;
}
